module.exports = __webpack_public_path__ + "static/Resume-f3071cc13bdd34fe09ae3c79bb18443e.pdf";